import ScrollAnimation from "../ScrollAnimation/ScrollAnimation";
import "./H1.css";

const H1 = ({ children }) => {
    return (
        <ScrollAnimation>
            <h1>{children}</h1>
        </ScrollAnimation>
    );
};

export default H1;
